import { Colors, IcChevronLeft, Text } from 'basic-ui-lib';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface HeaderMobileProps {
  title: string;
  iconRight?: ReactNode
  onBack?:() => void
}

const HeaderMobile = ({ title, iconRight, onBack }: HeaderMobileProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if(!onBack) {
      return navigate(-1);
    }
    onBack();
  };

  return (
    <Container>
      <BackButton onClick={() => handleBack()}>
        <IcChevronLeft />
      </BackButton>
      <Text title_h9 medium>{title}</Text>
      {iconRight ? iconRight : <RightSpace />}
    </Container>
  );
};

export default HeaderMobile;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.neutral.bg[1]};
  position: sticky;
  top: 0;
  box-shadow: 0px 4px 4px #0000001A;
  z-index: 1000;
  padding: 16px;
  z-index: 100;
`;

const BackButton = styled.button`
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: none;
  background: transparent;
`;

const RightSpace = styled.div`
  width: 40px;
`;
